import React, { PureComponent } from 'react'

import Signin, { CUISignin } from '../../components/Signin'
import ForgotPassword from '../../components/ForgotPassword'
import processBuilder from '../../shared/utils/processBuilder'
import { signInUpServiceConfig } from '../shared/config'
import injectWidget from '../shared/injectWidget'

const PROCESS_MAPPING = {
  cuiSignIn: CUISignin,
  signIn: Signin,
  forgotPassword: ForgotPassword,
}

class CUISigninWidget extends PureComponent {
  static propTypes = {
  }

  constructor(props) {
    super(props)
    this.processes = processBuilder(PROCESS_MAPPING, (Process, processProps = {}) => {
      this.setState({ Process, processProps })
    })
    this.state = {
      Process: CUISignin,
    }
  }

  render() {
    const { ...rest } = this.props
    const { Process, processProps } = this.state
    return (
      <Process
        {...rest}
        {...processProps}
        processes={this.processes}
      />
    )
  }
}

export default injectWidget({
  widget: CUISigninWidget,
  serviceConfig: signInUpServiceConfig,
})
